import { render, staticRenderFns } from "./GoodsPackage.vue?vue&type=template&id=004aa9e6&scoped=true"
import script from "./GoodsPackage.vue?vue&type=script&lang=ts"
export * from "./GoodsPackage.vue?vue&type=script&lang=ts"
import style0 from "./GoodsPackage.vue?vue&type=style&index=0&id=004aa9e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004aa9e6",
  null
  
)

export default component.exports